import { render, staticRenderFns } from "./Traffic.vue?vue&type=template&id=c6be6aea&scoped=true"
import script from "./Traffic.vue?vue&type=script&lang=js"
export * from "./Traffic.vue?vue&type=script&lang=js"
import style0 from "./Traffic.vue?vue&type=style&index=0&id=c6be6aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6be6aea",
  null
  
)

export default component.exports